import {
  Calendar,
  Home,
  Layers,
  Settings,
  CreditCard,
  Table,
  FileText,
  LogOut,
  File,
  UserCheck,
  BookOpen,
  Info,
  MessageCircle,
} from "react-feather";
import { getUser } from "../../Utils/externalFunctions";
import { admins } from "../../Constant";
import { FEATURE_SELECTION } from "../../Constant/FeatureSelection";

export const MENUITEMS = [];

const isAdmin = admins.includes(getUser());

FEATURE_SELECTION.includes("Indikator") &&
  MENUITEMS.push({
    menutitle: "Indikator",
    Items: [
      {
        title: "Indikator",
        icon: UserCheck,
        type: "sub",
        active: false,
        children: [
          FEATURE_SELECTION.includes("Capaian IK") && {
            path: `${process.env.PUBLIC_URL}/capaianik`,
            title: "Capaian IK",
            type: "link",
          },
          FEATURE_SELECTION.includes("Capaian SS") && {
            path: `${process.env.PUBLIC_URL}/capaianss`,
            title: "Capaian SS",
            type: "link",
          },
        ],
      },
    ],
  });

FEATURE_SELECTION.includes("Dashboard") &&
  MENUITEMS.push({
    menutitle: "Dashboard",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/dashboard`,
        icon: Home,
        title: "Dashboard",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Uang Muka") &&
  MENUITEMS.push({
    menutitle: "Uang Muka",
    Items: [
      {
        title: "Uang Muka",
        icon: CreditCard,
        type: "sub",
        active: false,
        children: [
          FEATURE_SELECTION.includes("Uang Muka Kegiatan") && {
            path: `${process.env.PUBLIC_URL}/umk`,
            title: "Uang Muka Kegiatan",
            type: "link",
          },
          FEATURE_SELECTION.includes("Uang Muka Operasional") && {
            path: `${process.env.PUBLIC_URL}/umo`,
            title: "Uang Muka Operasional",
            type: "link",
          },
        ],
      },
    ],
  });

FEATURE_SELECTION.includes("Anggaran") &&
  MENUITEMS.push({
    menutitle: "Anggaran",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/anggaran`,
        icon: Calendar,
        title: "Anggaran",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Akun Baru") &&
  MENUITEMS.push({
    menutitle: "Akun Baru",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/daftarakun`,
        icon: Table,
        title: "Akun Baru",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Realokasi") &&
  MENUITEMS.push({
    menutitle: "Realokasi",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/realokasi`,
        icon: Calendar,
        title: "Realokasi",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Transaksi") &&
  MENUITEMS.push({
    menutitle: "Transaksi",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/transaksi`,
        icon: Layers,
        title: "Transaksi",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Dokumen") &&
  MENUITEMS.push({
    menutitle: "Dokumen",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/dokumen`,
        icon: File,
        title: "SK & Dokumen",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Panduan") &&
  MENUITEMS.push({
    menutitle: "Panduan",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/panduan`,
        icon: File,
        title: "Panduan",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Timeline Anggaran") &&
  MENUITEMS.push({
    menutitle: "Timeline Anggaran",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/timeanggaran`,
        icon: BookOpen,
        title: "Timeline Anggaran",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Laporan") &&
  MENUITEMS.push({
    menutitle: "Laporan",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/laporan`,
        icon: FileText,
        title: "Laporan",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("FAQ") &&
  MENUITEMS.push({
    menutitle: "FAQ",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/faq`,
        icon: Info,
        title: "FAQ",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Aduan") &&
  MENUITEMS.push({
    menutitle: "Aduan",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/aduan`,
        icon: MessageCircle,
        title: "Aduan",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Kalender") &&
  isAdmin &&
  MENUITEMS.push({
    menutitle: "Kalender",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/calendar`,
        icon: Calendar,
        title: "Kalender",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("History") &&
  isAdmin &&
  MENUITEMS.push({
    menutitle: "History",
    Items: [
      {
        path: `${process.env.PUBLIC_URL}/system-log`,
        icon: FileText,
        title: "History",
        type: "link",
      },
    ],
  });

FEATURE_SELECTION.includes("Pengaturan") &&
  isAdmin &&
  MENUITEMS.push({
    menutitle: "Pengaturan",
    Items: [
      {
        title: "Pengaturan",
        icon: Settings,
        type: "sub",
        active: false,
        children: [
          FEATURE_SELECTION.includes("Pengaturan Unit Kerja") && {
            path: `${process.env.PUBLIC_URL}/pengaturanunitkerja`,
            title: "Pengaturan Unit Kerja",
            type: "link",
          },
          FEATURE_SELECTION.includes("Pengaturan User Role") && {
            path: `${process.env.PUBLIC_URL}/pengaturanuserrole`,
            title: "Pengaturan User Role",
            type: "link",
          },
          FEATURE_SELECTION.includes("Pengaturan Daftar Akun") && {
            path: `${process.env.PUBLIC_URL}/pengaturandaftarakun`,
            title: "Pengaturan Daftar Akun",
            type: "link",
          },
          FEATURE_SELECTION.includes("Pengaturan Sumber Dana") && {
            path: `${process.env.PUBLIC_URL}/pengaturansumberdana`,
            title: "Pengaturan Sumber Dana",
            type: "link",
          },
          FEATURE_SELECTION.includes("Pengaturan Kegiatan") && {
            path: `${process.env.PUBLIC_URL}/pengaturankegiatan`,
            title: "Pengaturan Kegiatan",
            type: "link",
          },
          FEATURE_SELECTION.includes("Pengaturan Jenis Kegiatan") && {
            path: `${process.env.PUBLIC_URL}/pengaturanjeniskegiatan`,
            title: "Pengaturan Jenis Kegiatan",
            type: "link",
          },
          FEATURE_SELECTION.includes("Pengaturan Kategori Kegiatan") && {
            path: `${process.env.PUBLIC_URL}/pengaturankategorikegiatan`,
            title: "Pengaturan Kategori Kegiatan",
            type: "link",
          },
        ],
      },
    ],
  });

MENUITEMS.push({
  menutitle: "Log Out",
  Items: [
    {
      path: `${process.env.PUBLIC_URL}/login`,
      icon: LogOut,
      title: "Log Out",
      type: "link",
    },
  ],
});
